import { Link } from "react-router-dom";

export default function TFDSelectCamps() {
	return (
		<div className="tfd-select-camps-page">
			{/* Hero with short text */}
			<section className="tf-hero-camps">
				<div className="hero-image-wrap">
					<img
						src="/images/select/camps-hero.jpg"
						alt="Camps Hero"
						className="hero-bg-image"
					/>
					<div className="overlay-dark" />
					<div className="hero-content themeflat-container">
						<h1 className="hero-title wow fadeInUp animated">
							TFD SELECT Camps
						</h1>
						<p className="hero-subtitle wow fadeInUp animated">
							Intensive football experiences to boost skills &amp; confidence
						</p>
						<Link to="/contact" className="flat-button wow fadeInUp animated">
							Upcoming Schedules
						</Link>
					</div>
				</div>
			</section>

			<section className="tf-camps-info main-content">
				<div className="themeflat-container">
					<div className="title-box center-title-box title-large">
						<h2 className="title-section wow fadeInUp animated">
							Upcoming Camps
						</h2>
						<p className="sub-title wow fadeInUp animated">
							Stay tuned for specific dates, or contact us for details.
						</p>
					</div>

					{/* Example of multiple camp "cards" in a row */}
					<div className="row">
						<div className="col-md-4 wow fadeInUp animated">
							<div className="camp-card">
								<img
									src="/images/select/camp1.jpg"
									alt="Camp 1"
									className="camp-image"
								/>
								<h4 className="camp-title">Foundation Camp (U8–U10)</h4>
								<p className="camp-dates">Jan 15th – Jan 17th</p>
								<p className="camp-desc">
									Focus on core skills, teamwork, and fun for younger players
									ready to step up their game.
								</p>
							</div>
						</div>

						<div
							className="col-md-4 wow fadeInUp animated"
							data-wow-delay="0.2s"
						>
							<div className="camp-card">
								<img
									src="/images/select/camp2.jpg"
									alt="Camp 2"
									className="camp-image"
								/>
								<h4 className="camp-title">Advanced Skills Camp (U11–U13)</h4>
								<p className="camp-dates">Feb 12th – Feb 14th</p>
								<p className="camp-desc">
									Hone technical mastery, positional drills, and
									mini-tournaments led by experienced TFD coaches.
								</p>
							</div>
						</div>

						<div
							className="col-md-4 wow fadeInUp animated"
							data-wow-delay="0.4s"
						>
							<div className="camp-card">
								<img
									src="/images/select/camp3.jpg"
									alt="Camp 3"
									className="camp-image"
								/>
								<h4 className="camp-title">Elite Challenge Camp (U14+)</h4>
								<p className="camp-dates">March 20th – March 22nd</p>
								<p className="camp-desc">
									Intensive sessions focusing on tactical awareness, mental
									resilience, and leadership on the pitch.
								</p>
							</div>
						</div>
					</div>

					<div className="text-center mt-5">
						<Link to="/contact" className="flat-button wow fadeInUp animated">
							Contact Us for More Info
						</Link>
					</div>
				</div>
			</section>
		</div>
	);
}
